<template>
  <div class="page flex-col">
    <div class="top-bar flex-row">
      <img class="logo" referrerpolicy="no-referrer" src="./assets/img/SketchPng1b873447787c9cbb3e41368859a9d2c662c59bd8506395ceca20ebd4c958e4c0.png" />
      <span class="nav-link" @click="showContact = true">联系我们</span>
    </div>
    <div class="banner flex-col"><span class="banner-title">基于AI的建筑业数字化建造互联网平台</span></div>

    <div class="main-area flex-row">
      <div class="sidebar flex-col">
        <div class="nav-item" @click="$router.push('/lanhu_quanguochengshuzihua')">全过程数字化管控</div>
        <div class="nav-item" @click="$router.push('/lanhu_zhengxiangshejijieduan')">正向设计阶段</div>
        <div class="nav-item" @click="$router.push('/lanhu_heidengshengchanjieduan')">黑灯生产阶段</div>
        <div class="nav-item active" @click="$router.push('/lanhu_wurenshigong')">无人/少人施工阶段</div>
        <div class="nav-item" @click="$router.push('/lanhu_zhihuiyunwei')">智慧运维阶段</div>
        <div class="nav-item" @click="$router.push('/lanhu_qita')">其他AI智能体</div>
        <div class="nav-item" @click="showContact = true">定制开发模块</div>
      </div>

      <!-- 单卡片居中 -->
      <div class="content-area-single">
        <div class="card-box-wide flex-col">
          <span class="card-title">机器人控制模块</span>
          <span class="card-sub">（定制）</span>
          <img class="card-icon" referrerpolicy="no-referrer" src="./assets/img/SketchPngd6441087fd632a3a4d8106aae7c49968e327173ac9f141a55be53c2197571703.png" />
          <span class="card-desc">
            本模块作为机器人集中管控平台，面向建筑机电、管线安装、工业基建等施工场景，承接上游生产、设计数据，将施工任务转化为机器人可执行指令，实现远程化、集中化、智能化管控，大幅降低现场作业人员数量，降低高空、高危环境下的施工安全风险。同时可根据项目工况、机器人型号、现场管理流程做深度定制，兼容不同品牌、不同功能的施工机器人，适配各类无人 / 少人施工场景落地。
          </span>
          <div class="download-btn flex-col" @click="showContact = true"><span class="btn-text">联系我们</span></div>
        </div>
      </div>
    </div>

    <div class="footer flex-row">
      <img class="footer-logo" referrerpolicy="no-referrer" src="./assets/img/SketchPng23c7966a2d1963c6b88ae89421a6a417dd7b177ac534af52d26b60f665e3e49f.png" />
      <span class="footer-text">赢技科技发展（杭州）有限公司&nbsp;<br/>联系我们：yingji&#64;yjyunjz.com<br/>版权所有&nbsp;浙ICP备1214545号-1</span>
    </div>

    <!-- 联系我们弹窗 -->
    <div class="contact-modal-ask" v-if="showContact" @click.self="showContact = false">
      <div class="contact-modal">
        <div class="contact-modal-header">
          <span class="contact-modal-title">联系我们</span>
          <span class="contact-modal-close" @click="showContact = false">✕</span>
        </div>
        <div class="contact-modal-body">
          <div class="contact-item">
            <span class="contact-label">公司名称：</span>
            <span class="contact-value">赢技科技发展（杭州）有限公司</span>
          </div>
          <div class="contact-item">
            <span class="contact-label">联系邮箱：</span>
            <a class="contact-value contact-link" href="mailto:yingji@yjyunjz.com">yingji@yjyunjz.com</a>
          </div>
          <div class="contact-item">
            <span class="contact-label">官方网站：</span>
            <span class="contact-value">www.yjyunjz.com</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { data() { return { showContact: false }; } };
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
.contact-modal-ask {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 9999;
}
.contact-modal { background: #fff; border-radius: 12px; padding: 32px 40px; min-width: 380px; box-shadow: 0 16px 48px rgba(0,0,0,0.2); }
.contact-modal-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 24px; }
.contact-modal-title { font-size: 20px; font-weight: 700; color: #1a1a2e; }
.contact-modal-close { cursor: pointer; font-size: 18px; color: #999; padding: 4px; }
.contact-modal-close:hover { color: #333; }
.contact-modal-body { display: flex; flex-direction: column; gap: 16px; }
.contact-item { display: flex; align-items: flex-start; font-size: 15px; line-height: 1.6; }
.contact-label { color: #666; white-space: nowrap; min-width: 90px; }
.contact-value { color: #1a1a2e; font-weight: 500; }
.contact-link { color: #2563eb; text-decoration: none; }
.contact-link:hover { text-decoration: underline; }
.download-btn { cursor: pointer; transition: opacity .2s, transform .15s; }
.download-btn:hover { opacity: .85; transform: scale(1.03); }
</style>
